import styled from 'styled-components';
import { ColorSet } from 'src/redux/reducers/theme';

export const DashedContainer = styled.div<{ color?: keyof ColorSet }>`
  border: 1px dashed ${({ theme, color }) => (color ? theme.colors[color] : theme.colors.cflowerBlue)};
  border-radius: 6px;
  padding: 9px 12px;
`;
